export const SUCCESS_STATUS = 'success';
export const ERROR_STATUS = 'error';
export const LOADING_STATUS = 'loading';

export default {
    SUCCESS_STATUS,
    ERROR_STATUS,
    LOADING_STATUS,
};